if (!customElements.get('quote-request-modal')) {
  class QuoteRequestModal extends HTMLElement {
    connectedCallback() {
      this.dialog = this.querySelector('dialog');
      this.trigger = this.querySelector('[data-quote-open]');
      this.closeButton = this.querySelector('[data-quote-close]');

      this.trigger?.addEventListener('click', () => this.dialog.showModal());
      this.closeButton?.addEventListener('click', () => this.dialog.close());
      this.dialog?.addEventListener('click', (event) => {
        if (event.target === this.dialog) this.dialog.close();
      });

      if (this.dialog?.hasAttribute('data-open-on-load')) {
        this.dialog.showModal();
      }
    }
  }

  customElements.define('quote-request-modal', QuoteRequestModal);
}
